import { Filter, TrendingUp } from "lucide-react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Badge } from "@/components/ui/badge";
import { FeedFilterType, FeedSortType } from "@/types/feedFilters";

interface FeedFilterProps {
  currentFilter: FeedFilterType;
  currentSort: FeedSortType;
  onFilterChange: (filter: FeedFilterType) => void;
  onSortChange: (sort: FeedSortType) => void;
  itemCount: number;
}

export function FeedFilter({
  currentFilter,
  currentSort,
  onFilterChange,
  onSortChange,
  itemCount,
}: FeedFilterProps) {
  const filterOptions = [
    { value: 'all', label: '🌟 All Activity' },
    { value: 'reviews', label: '📝 Reviews Only' },
    { value: 'ratings', label: '⭐ Ratings Only' },
    { value: 'milestones', label: '🏆 Milestones' },
    { value: 'reading', label: '📖 Reading Updates' },
    { value: 'finished', label: '✅ Finished Books' },
  ];

  const sortOptions = [
    { value: 'recent', label: 'Most Recent' },
    { value: 'popular', label: 'Most Cheered' },
  ];

  return (
    <div className="flex flex-wrap items-center gap-2">
      <div className="flex items-center gap-2">
        <Filter className="w-4 h-4 text-muted-foreground" />
        <Select value={currentFilter} onValueChange={(value) => onFilterChange(value as FeedFilterType)}>
          <SelectTrigger className="w-[180px]">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {filterOptions.map((option) => (
              <SelectItem key={option.value} value={option.value}>
                {option.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      <div className="flex items-center gap-2">
        <TrendingUp className="w-4 h-4 text-muted-foreground" />
        <Select value={currentSort} onValueChange={(value) => onSortChange(value as FeedSortType)}>
          <SelectTrigger className="w-[160px]">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {sortOptions.map((option) => (
              <SelectItem key={option.value} value={option.value}>
                {option.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      {itemCount > 0 && (
        <Badge variant="secondary" className="ml-1">
          {itemCount} {itemCount === 1 ? 'item' : 'items'}
        </Badge>
      )}
    </div>
  );
}
